import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { useHistory, useLocation } from 'react-router-dom';
import queryparse from 'tricks/string/queryparse';
import querystringify from 'tricks/string/querystringify';
import filterObject from 'utils/filterObject';
/*
 * Access or update the search params of the current location.
 * Mimics the useSearchParams hook new to react-router-dom@v6 (we're currently using v5)
 *
 * TODO [react-router-dom@>=6]: Use the built-in useSearchParams hook then remove this hook
 */

export default function useSearchParams() {
  var location = useLocation();
  var history = useHistory();
  var search = location.search;
  var searchParams = queryparse(search);
  function setSearchParams(newParams) {
    var newParamsObject;
    if (typeof newParams === 'function') {
      newParamsObject = newParams(searchParams);
    } else {
      newParamsObject = _objectSpread(_objectSpread({}, searchParams), newParams);
    }
    history.replace(_objectSpread(_objectSpread({}, location), {}, {
      search: "?".concat(querystringify(filterObject(newParamsObject)))
    }));
  }
  return [searchParams, setSearchParams];
}